import DOMPurify from 'dompurify'

(function () {
  if (window.trustedTypes && window.trustedTypes.createPolicy) {
    window.trustedTypes.createPolicy('default', {
      createHTML: (string) => {
        return DOMPurify.sanitize(string, {
          RETURN_TRUSTED_TYPE: true,
          ADD_TAGS: ['use'],
          ADD_ATTR: ['xlink:href', 'href'],
        })
      },
      createScript: (string) => string,
      createScriptURL: (string) => string
    })
  }
})()
